<template>
  <el-dialog :visible.sync="visible" title="Interpreter Details" width="60%">
    <div class="form-group">
      <div class="box-row">
        <div class="box-col box-col-left">Name</div>
        <div class="box-col-right">
          <input class="textbox w-100" v-model="curItem.InterpreterName" placeholder="Interpreter Name" :class="hasError && interpreterNameError ? 'is-invalid' : ''" />
          <div v-if="hasError && interpreterNameError" class="text-danger">{{ interpreterNameError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Company Name</div>
        <div class="box-col-right">
          <input class="textbox w-100" v-model="curItem.InterpreterCompanyName" placeholder="Interpreter Company Name" :class="hasError && interpreterCompanyError ? 'is-invalid' : ''"  />
          <div v-if="hasError && interpreterCompanyError" class="text-danger">{{ interpreterCompanyError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Contact Number</div>
        <div class="box-col-right">
          <input class="textbox w-100" v-model="curItem.InterpreterContactNumber" placeholder="Interpreter Contact Number (12 characters if provided)" :class="hasError && interpreterPhoneError ? 'is-invalid' : ''" @blur="trimField('InterpreterContactNumber')" />
          <div v-if="hasError && interpreterPhoneError" class="text-danger">{{ interpreterPhoneError }}</div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left">Contact Email</div>
        <div class="box-col-right">
          <input class="textbox w-100" v-model="curItem.InterpreterContactEmail" placeholder="Interpreter Contact Email" :class="hasError && interpreterEmailError ? 'is-invalid' : ''" />
          <div v-if="hasError && interpreterEmailError" class="text-danger">{{ interpreterEmailError }}</div>
        </div>
      </div>
      <div class="box-row" v-if="user && user.type >= 3">
        <div class="box-col box-col-left">Cost</div>
        <div class="box-col-right">
          <el-input-number :precision="0" class="w-100" :class="hasError && interpreterCostError ? 'is-invalid' : ''" v-model="curItem.InterpreterCost" controls-position="right" />
          <div v-if="hasError && interpreterCostError" class="text-danger">{{ interpreterCostError }}</div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <v-btn @click="clickSave" dark>Save</v-btn>
      <v-btn class="white-button ml-4" @click="visible = false" dark>Cancel</v-btn>
    </div>
  </el-dialog>
</template>
<script>
import utilities from "../../assets/js/utilities";

export default {
  name: 'InterpreterDetailDialog',
  props: ['user'],
  data() {
    return {
      visible: false,
      curItem: {},
      hasError: false
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.hasError = false
      }
    },
  },
  computed: {
    interpreterNameError() {
      return utilities.getAdminBookingInterpreterNameError(this.curItem.InterpreterName)
    },
    interpreterCompanyError() {
      return utilities.getAdminBookingInterpreterCompanyError(this.curItem.InterpreterCompanyName)
    },
    interpreterPhoneError() {
      return utilities.getLandPhoneError(this.curItem.InterpreterContactNumber)
    },
    interpreterEmailError() {
      return utilities.getAdminBookingInterpreterEmailError(this.curItem.InterpreterContactEmail)
    },
    interpreterCostError() {
      if (!this.user || this.user.type < 3) {
        return ''
      }
      return utilities.getAdminBookingInterpreterCostError(this.curItem.InterpreterCost)
    },
  },
  methods: {
    trimField(key) {
      const v = this.curItem[key]
      if (v === undefined || v === null || typeof v !== 'string') {
        return
      }
      this.$set(this.curItem, key, utilities.normalizeAuPhoneInput(v))
    },
    trimInterpreterFields() {
      ['InterpreterContactNumber'].forEach((k) => {
        this.trimField(k)
      })
    },
    clickSave() {
      this.trimInterpreterFields()
      const errs = [
        this.interpreterNameError,
        this.interpreterCompanyError,
        this.interpreterPhoneError,
        this.interpreterEmailError,
        this.interpreterCostError,
      ].filter(Boolean)
      if (errs.length > 0) {
        this.hasError = true
        return
      }
      this.hasError = false
      this.$emit('clickSave', this.curItem)
      this.visible = false
    },
  },
}
</script>

<style scoped>

</style>
